import Notificacao from '@/domain/notificacao/Notificacao';

export default class AtividadeNotificacao {
  constructor(
    IdAtividade = null,
    Atividade = 'Descrição da atividade...',
    TipoNotificacao = 'Atividade',
    Notificacoes = [new Notificacao(), new Notificacao(), new Notificacao()]
  ) {
    this.IdAtividade = IdAtividade;
    this.TipoNotificacao = TipoNotificacao;
    this.Atividade = Atividade;
    this.Notificacoes = Notificacoes;
  }
}